import React from "react";
import leftArrow from "../assets/images/leftArrow.svg"; // Back icon
import close from "../assets/images/close.svg"; // Close icon
import { useNavigate } from "react-router-dom";

const AppHeader = ({ title, onBack, onClose }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // Goes back to the previous page in history
  };
  return (
    <header className="sticky top-0 w-full z-20 bg-white flex items-center justify-between px-4 py-3 border-b border-gray-200">
      {/* Back Button */}
      <button
        onClick={onBack || goBack}
        aria-label="Back"
        className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 hover:bg-gray-50"
      >
        <img src={leftArrow} alt="Back" className="w-4 h-4" />
      </button>

      {/* Title */}
      <h1 className="text-base font-semibold text-brand-secondary">{title}</h1>

      {/* Close Button */}
      <button
        onClick={onClose}
        aria-label="Close"
        className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 hover:bg-gray-50"
      >
        <img src={close} alt="Close" className="w-4 h-4" />
      </button>
    </header>
  );
};

export default AppHeader;
